"use client";

import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import { createProductService } from "@/shared/api/services/productService";
import { useBuyerService } from "@/shared/auth/hooks";

import { homeKeys } from "@/features/home/queries/keys";

export function usePopularBrands() {
  const service = useBuyerService(createProductService);

  return useQuery({
    queryKey: homeKeys.list({ type: "popular-brands" }),
    queryFn: () => service.getPopularBrands(),
  });
}

export function useHomePopularBrands() {
  const service = useBuyerService(createProductService);

  return useQuery({
    queryKey: homeKeys.list({ type: "home-popular-brands" }),
    queryFn: () => service.getHomePopularBrands(),
  });
}

export function useHomeFeaturedBrands() {
  const service = useBuyerService(createProductService);

  return useQuery({
    queryKey: homeKeys.list({ type: "home-featured-brands" }),
    queryFn: () => service.getHomeFeaturedBrands(),
  });
}

export function usePopularProducts() {
  const service = useBuyerService(createProductService);

  return useQuery({
    queryKey: homeKeys.list({ type: "home-popular-products" }),
    queryFn: () => service.getHomePopularProducts(),
  });
}

export function useNewBrands() {
  const service = useBuyerService(createProductService);

  return useQuery({
    queryKey: homeKeys.list({ type: "new-brands" }),
    queryFn: () => service.getNewBrands(),
  });
}

export function useNewProducts() {
  const service = useBuyerService(createProductService);

  return useQuery({
    queryKey: homeKeys.list({ type: "home-new-products" }),
    queryFn: () => service.getHomeNewProducts(),
  });
}

export function useRecommendedFeed() {
  const service = useBuyerService(createProductService);

  return useInfiniteQuery({
    queryKey: homeKeys.list({ type: "home-feed" }),
    queryFn: ({ pageParam }) => service.getHomeFeed(pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.products?.pagination;
      if (!pagination) return undefined;
      const currentPage = Number(pagination.current_page);
      return currentPage < pagination.total_page ? currentPage + 1 : undefined;
    },
  });
}
